export function interpolate(template: string, vars: Record<string, any>) {
  return template.replace(/{{(.*?)}}/g, (_, key) => vars[key] ?? "");
}
